/* Image Zoom Modal */
(function () {
  const state = {
    modal: null,
    modalImage: null,
    container: null,
    loader: null,
    isDragging: false,
    startX: 0,
    startY: 0,
    currentX: 0,
    currentY: 0,
    bound: false,
  };

  function ensureBound() {
    if (state.bound) return state.modal && state.modalImage;

    state.modal = document.getElementById('imageZoomModal');
    if (!state.modal) return false;

    state.modalImage = state.modal.querySelector('.image-zoom-modal__image');
    state.container = state.modal.querySelector('.image-zoom-modal__container');
    state.loader = state.modal.querySelector('.image-zoom-modal__loader');
    const closeButton = state.modal.querySelector('.image-zoom-modal__close');

    if (!state.modalImage) return false;

    if (closeButton) closeButton.addEventListener('click', closeModal);
    setupDragFunctionality();
    state.bound = true;
    return true;
  }

  function openModal(imageSrc, imageAlt) {
    if (!ensureBound()) return;

    // Show loader
    if (state.loader) state.loader.classList.remove('hidden');

    // Hide previous image
    state.modalImage.classList.remove('loaded');
    state.modalImage.src = '';
    state.modalImage.alt = imageAlt || '';

    // Reset position
    state.currentX = 0;
    state.currentY = 0;
    updateImagePosition();

    // Show modal
    state.modal.classList.add('active');

    // Prevent body scroll
    document.body.style.overflow = 'hidden';

    // Load new image
    const img = new Image();
    img.onload = () => {
      state.modalImage.src = imageSrc;
      state.modalImage.classList.add('loaded');

      // Hide loader
      if (!state.loader) return;
      setTimeout(() => state.loader.classList.add('hidden'), 100);
    };
    img.src = imageSrc;
  }

  function closeModal() {
    if (!state.modal) return;
    state.modal.classList.remove('active');
    // Restore body scroll
    document.body.style.overflow = '';
  }

  function setupDragFunctionality() {
    if (!state.modalImage) return;

    // Touch events
    state.modalImage.addEventListener('touchstart', (e) => {
      handleDragStart(e.touches[0].clientX, e.touches[0].clientY);
      e.preventDefault();
    });

    state.modalImage.addEventListener('touchmove', (e) => {
      if (!state.isDragging) return;
      handleDragMove(e.touches[0].clientX, e.touches[0].clientY);
      e.preventDefault();
    });

    state.modalImage.addEventListener('touchend', handleDragEnd);

    // Mouse events (for testing on desktop)
    state.modalImage.addEventListener('mousedown', (e) => {
      handleDragStart(e.clientX, e.clientY);
      e.preventDefault();
    });

    document.addEventListener('mousemove', (e) => {
      if (state.isDragging) handleDragMove(e.clientX, e.clientY);
    });

    document.addEventListener('mouseup', handleDragEnd);
  }

  function handleDragStart(clientX, clientY) {
    state.isDragging = true;
    state.startX = clientX - state.currentX;
    state.startY = clientY - state.currentY;
    state.modalImage.classList.add('dragging');
  }

  function handleDragMove(clientX, clientY) {
    if (!state.isDragging || !state.container) return;

    // Calculate new position
    const newX = clientX - state.startX;
    const newY = clientY - state.startY;

    // Get container dimensions
    const containerRect = state.container.getBoundingClientRect();

    // Image is rendered at 200% of container (min-width: 200%, min-height: 200% in CSS)
    const zoomFactor = 2;
    const renderedWidth = containerRect.width * zoomFactor;
    const renderedHeight = containerRect.height * zoomFactor;

    // Calculate boundaries (allow 20% of image to go outside)
    const allowedOffset = 0.2; // 20%
    const maxX = (renderedWidth - containerRect.width) / 2 + (renderedWidth * allowedOffset);
    const maxY = (renderedHeight - containerRect.height) / 2 + (renderedHeight * allowedOffset);

    // Apply boundary limits
    state.currentX = Math.max(-maxX, Math.min(maxX, newX));
    state.currentY = Math.max(-maxY, Math.min(maxY, newY));

    updateImagePosition();
  }

  function handleDragEnd() {
    state.isDragging = false;
    if (state.modalImage) state.modalImage.classList.remove('dragging');
  }

  function updateImagePosition() {
    if (!state.modalImage) return;
    state.modalImage.style.transform = `translate(${state.currentX}px, ${state.currentY}px)`;
  }

  window.openImageZoomModal = openModal;
})();
